import { useRouter } from 'next/router'
// Components
import Button from '../newButton/Button'
import styles from './FinancingModal.module.scss'
import rootStyles from '../../pages/puppy/[id].module.scss'

export default function FinancingModal({ setShowFinancingModal }) {
  const router = useRouter()

  return (
    <div
      className={styles.background}
      onClick={() => setShowFinancingModal(false)}
    >
      <div className={styles.modal}>
        <div className={styles.header}>
          <img
            src="/puppy/close.svg"
            onClick={() => setShowFinancingModal(false)}
            alt="close icon"
          />
        </div>
        <div className={styles.content}>
          <h4 className={rootStyles.subtitle}>Get Pre-Approved Today!</h4>
          <p className={rootStyles.subtitle}>
            Apply for financing to help with the purchase of your forever
            furbaby.
          </p>
          <p className={rootStyles.subtitle}>
            Financing is provided by our trusted lending partner Terrace
            Finance, and is <span>available for all credit levels.</span>
          </p>
          <p className={styles.text}>
            *Financing is <b>not available</b> in the following areas:
            California, Connecticut, Massachusetts, Minnesota, Nevada, New
            Jersey, New York, Vermont, Washington, Wisconsin, Puerto Rico, and
            Canada.
          </p>
          <Button
            title="Apply now!"
            theme={['tall', 'green-solid']}
            onClick={() => router.push('https://cutt.ly/friend-a-puppy')}
          />
        </div>
      </div>
    </div>
  )
}
